import {AbstractControl, ValidatorFn, Validators} from '@angular/forms';
import {ControlBuilder} from '../../dynamic-field/control-builder.type';
import {buildAsyncValidators, buildDefaultValidators} from '../../dynamic-field/default-control-builder';
import { FileSelectFieldConfig } from './file-select-field.config';
import { CustomValidationError } from '../../validation/custom-validation-error';
import { MydocmaFile } from '@mydocma/common/src/lib/file';

export const fileSelectFieldBuilder: ControlBuilder = (fieldConfig: FileSelectFieldConfig, formBuilder) => {
    const {disabled, value} = fieldConfig;

    const validators = buildFileSelectFieldValidators(fieldConfig);

    const asyncValidators = buildAsyncValidators(fieldConfig);

    return formBuilder.control(
        {
            disabled,
            value: value || null
        },
        validators,
        asyncValidators
    );
};


export const buildFileSelectFieldValidators: (fieldConfig: FileSelectFieldConfig) => ValidatorFn[] =
    (config): ValidatorFn[] => {
        const validators = buildDefaultValidators(config);
        if (config.maxSizeTotal) {
            validators.push(customMaxSizeTotalValidator.bind(this, config))
        }

        return validators;
    };

export function customMaxSizeTotalValidator(field: FileSelectFieldConfig, control: AbstractControl): CustomValidationError {
    const arrayOfFiles = control.value as MydocmaFile[];
    let totalFileSize = 0;
    if(arrayOfFiles && arrayOfFiles.length > 0) {
        arrayOfFiles.forEach(file => {
            totalFileSize += file.size;
        })
        if(totalFileSize > field.maxSizeTotal) {
                const KB = field.maxSizeTotal / 1024;
                const MB = KB / 1024;
                const GB = MB / 1024;
                let formattedMaxSize: string;
                if (GB >= 1) {
                    formattedMaxSize = `${GB % 1 !== 0 ? GB.toFixed(2) : GB} GB`;
                } else if (MB >= 1) {
                    formattedMaxSize = `${MB % 1 !== 0 ? MB.toFixed(2) : MB} MB`;
                } else {
                    formattedMaxSize = `${KB % 1 !== 0 ? KB.toFixed(2) : KB} KB`;
                }
                return { mydocmaCustomMaxSizeTotalError: {text: 'FORM.fields.errors.maxSizeTotal', formattedMaxSize: formattedMaxSize}};
            }
    }
}

